import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateImageTypeFailure,
  CreateImageTypeRequest,
  CreateImageTypeSuccess,
  DeleteImageTypeFailure,
  DeleteImageTypeRequest,
  DeleteImageTypeSuccess,
  FetchImageTypeFailure,
  FetchImageTypeRequest,
  FetchImageTypeSuccess,
  FetchImageTypesFailure,
  FetchImageTypesRequest,
  FetchImageTypesSuccess,
  UpdateImageTypeFailure,
  UpdateImageTypeRequest,
  UpdateImageTypeSuccess,
} from './image-types.actions'
import { ImageTypesService } from './image-types.service'
import * as ImageTypes from './image-types.types'

@Injectable()
export class ImageTypesEffects {
  constructor(
    private actions: Actions,
    private imageTypesService: ImageTypesService,
    private router: Router,
  ) {}

  FetchImageTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(ImageTypes.FETCH_IMAGE_TYPES_REQUEST),
      switchMap((action: FetchImageTypesRequest) => {
        return this.imageTypesService.fetchImageTypes(action.payload).pipe(
          map((result) => {
            return new FetchImageTypesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchImageTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchImageType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ImageTypes.FETCH_IMAGE_TYPE_REQUEST),
      switchMap((action: FetchImageTypeRequest) => {
        return this.imageTypesService.fetchImageType(action.id).pipe(
          map((result) => {
            return new FetchImageTypeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchImageTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteImageType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ImageTypes.DELETE_IMAGE_TYPE_REQUEST),
      switchMap((action: DeleteImageTypeRequest) => {
        return this.imageTypesService.deleteImageType(action.id).pipe(
          switchMap((result) => {
            return [new DeleteImageTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteImageTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateImageType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ImageTypes.CREATE_IMAGE_TYPE_REQUEST),
      switchMap((action: CreateImageTypeRequest) => {
        return this.imageTypesService.createImageType(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/image-types'])
            return [new CreateImageTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateImageTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateImageType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ImageTypes.UPDATE_IMAGE_TYPE_REQUEST),
      switchMap((action: UpdateImageTypeRequest) => {
        return this.imageTypesService
          .updateImageType(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/image-types'])
              return [new UpdateImageTypeSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateImageTypeFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
